import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProtvista = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 16 16",
	fill: "currentColor",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M0 0h2v14h14v2H0V0z" }), /* @__PURE__ */ _jsx("path", { d: "M6.92 2l-2.9 9.86.96.28L7.08 5l2.28 5.47 2.07-2.58 1.64 2.86.86-.5-2.36-4.14-1.93 2.42L6.92 2z" })]
});
export default SvgProtvista;
